module.exports = __webpack_public_path__ + "img/item-5(1920)new.87ce17e2.jpg";